import { useState } from "react";
import { HiOutlineCube } from "react-icons/hi2";
import { IoMdStarOutline } from "react-icons/io";
import { PiHeart } from "react-icons/pi";
import { SlBag } from "react-icons/sl";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import PrimaryButton from "../../components/buttons/PrimaryButton";
import SecondaryButton from "../../components/buttons/SecondaryButton";
import UnderlineButton from "../../components/buttons/UnderlineButton";
import TextField from "../../components/input/TextField";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/section/footer/Footer";
import MenuSpacer from "../../components/spacer/MenuSpacer";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";
import { validateEmail, validatePassword } from "../../utils/validators";

const Wrapper = styled.div``;

const Container = styled.div`
  max-width: 420px;
  margin: 0 auto;
  padding-top: 10px;

  @media (max-width: 950px) {
    max-width: 100%;
    padding: 40px 20px 0;
  }
`;

const Title = styled.div`
  text-align: center;
  padding-bottom: 32px;
  color: ${colors.black};
  text-transform: uppercase;
  font-size: ${fontSize.s};
`;

const FormWrapper = styled.div``;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: ${fontSize.xxs};
  }

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    appearance: none;
    border: 1px solid ${colors.border};
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease;
  }

  input[type="checkbox"]:checked::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 5px;
    width: 4px;
    height: 8px;
    border: solid ${colors.black};
    border-width: 0 1px 1px 0;
    transform: rotate(45deg);
  }
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin: 32px 0;
  background-color: ${colors.line};
`;

const FeaturesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
`;

const Feature = styled.div`
  display: flex;
  gap: 6px;
  flex-direction: column;
  text-align: center;
  align-items: center;
  max-width: 72px;

  svg {
    color: black;
  }

  span {
    font-size: ${fontSize.xxs};
  }
`;

function SigninPage() {
  const navigate = useNavigate();
  const [rememberMe, setRememberMe] = useState(false);

  const handleCheckboxChange = (e) => {
    setRememberMe(e.target.checked);
  };

  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (field) => (e) => {
    setFormValues({ ...formValues, [field]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = {
      email: validateEmail(formValues.email),
      password: validatePassword(formValues.password),
    };

    setErrors(validationErrors);

    if (!Object.values(validationErrors).some(Boolean)) {
      console.log("Form submitted:", { ...formValues, rememberMe });
      // call your API here
    }
  };

  const features = [
    { icon: <IoMdStarOutline size={24} />, label: "Access Exclusives" },
    { icon: <PiHeart size={22} />, label: "Save Your Favourites" },
    { icon: <SlBag size={20} />, label: "Faster Checkout" },
    { icon: <HiOutlineCube size={24} />, label: "Manage Orders" },
  ];

  return (
    <Wrapper>
      <Navbar />
      <MenuSpacer />
      <Container>
        <FormWrapper>
          <Title>LOGIN TO YOUR ACCOUNT</Title>
          <Form onSubmit={handleSubmit}>
            <TextField
              text="EMAIL ADDRESS"
              value={formValues.email}
              error={errors.email}
              onChange={handleChange("email")}
            />

            <TextField
              text="PASSWORD"
              type="password"
              value={formValues.password}
              error={errors.password}
              onChange={handleChange("password")}
            />
            <CheckboxWrapper>
              <label>
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={handleCheckboxChange}
                />
                Remember Me
              </label>
              <UnderlineButton placeholder="Forgot password?" />
            </CheckboxWrapper>
            <PrimaryButton type="submit" title="LOGIN" width="100%" />
          </Form>
        </FormWrapper>
        <Line />
        <Title>New to PEAK PASHMINA?</Title>
        <SecondaryButton
          title={"CREATE AN ACCOUNT"}
          onClick={() => navigate("/signup")}
          width="min(100%, 100%)"
        />

        <FeaturesWrapper>
          {features.map((feature, index) => (
            <Feature key={index}>
              {feature.icon}
              <span>{feature.label}</span>
            </Feature>
          ))}
        </FeaturesWrapper>
      </Container>
      <Footer />
    </Wrapper>
  );
}

export default SigninPage;
